export const GPS_DECIMAL_PLACES = 7;


// WEBPACK FOOTER //
// ./src/config/constants/index.js